// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-catalog-category-categories-type-1-mainCategories-bscaj{display:grid}.components-catalog-category-categories-type-1-mainCategories-bscaj.components-catalog-category-categories-type-1-desktop-dtete{grid-gap:24px;grid-template-columns:repeat(5,1fr)}.components-catalog-category-categories-type-1-mainCategories-bscaj.components-catalog-category-categories-type-1-mobile-bvlsu{grid-gap:12px;grid-template-columns:repeat(3,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainCategories": "components-catalog-category-categories-type-1-mainCategories-bscaj",
	"desktop": "components-catalog-category-categories-type-1-desktop-dtete",
	"mobile": "components-catalog-category-categories-type-1-mobile-bvlsu"
};
module.exports = ___CSS_LOADER_EXPORT___;
